export const COOKIE_MODAL_TRIGGER_IDENTIFIER = '.js-kmcc-extended-modal-button';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/cookieModalTrigger.config.js